import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default class extends Controller {
  initialize() {
    this.handleResize();
  }

  initializeSwiper() {
    var w = window.innerWidth;
    var sliderClass = w < 768 ? ".js-banner-slider-medium-sp" : ".js-banner-slider-medium-pc";
    var paginationClass = w < 768 ? ".js-banner-slider-medium-pagination-sp" : ".js-banner-slider-medium-pagination-pc";

    this.swiper = new Swiper(sliderClass, {
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      slidesPerView: "auto",
      centeredSlides: true,
      lazy: true,
      loop: true,
      spaceBetween: 8,
      speed: 300,
      breakpoints: {
        768: {
          spaceBetween: 16,
        },
      },
      pagination: {
        el: paginationClass,
        clickable: true, // クリック可能にする
      },
      navigation: {
        nextEl: ".js-banner-slider-medium-next",
        prevEl: ".js-banner-slider-medium-prev",
      },
      keyboard: {
        enabled: true,
      },
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = undefined;
    }
  }

  handleResize() {
    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var sliderClass = w < 768 ? ".js-banner-slider-medium-sp" : ".js-banner-slider-medium-pc";
    var slideCount = $(sliderClass).find(".swiper-slide").length;

    this.destroySwiper();

    if (slideCount === 1) {
      // スライドが1つの場合はSwiperを初期化しない
      return;
    } else if (w >= 768 && slideCount === 2) {
      // スライドが2つの場合はPCサイズではSwiperを初期化しない
      return;
    }

    this.initializeSwiper();
  }

  //再生/停止ボタン
  sliderstop(e) {
    if ($(e.currentTarget).hasClass("is-pause")) {
      this.swiper.autoplay.start();
      $(e.currentTarget).removeClass("is-pause");
      $(e.currentTarget).text("停止する");
    } else {
      this.swiper.autoplay.stop();
      $(e.currentTarget).addClass("is-pause");
      $(e.currentTarget).text("再生する");
    }
  }
}
